import React from 'react';
import { Download, Settings2, Database, Save, Share2, Edit2, Trash2, Sparkles, Copy, Maximize2, Minimize2, LocateFixed, Layers, MapPin, Cpu } from 'lucide-react';
interface MapActionsMenuProps {
  isBackground?: boolean;
  onEditWithAI: () => void;
  onToggleBackground?: () => void;
  onDuplicate?: () => void;
  onRemove?: () => void;
  onClose: () => void;
  showResetPosition?: boolean;
  onResetPosition?: () => void;
  // Compact mode extras
  compactMode?: boolean;
  onOpenLayers?: () => void;
  activeLayersCount?: number;
  onOpenPOI?: () => void;
  activePOIsCount?: number;
  onOpenModel?: () => void;
  selectedModel?: string;
  // Medium mode: only show model in menu
  showModelInMenu?: boolean;
}
export function MapActionsMenu({
  isBackground,
  onEditWithAI,
  onToggleBackground,
  onDuplicate,
  onRemove,
  onClose,
  showResetPosition,
  onResetPosition,
  compactMode,
  onOpenLayers,
  activeLayersCount = 0,
  onOpenPOI,
  activePOIsCount = 0,
  onOpenModel,
  selectedModel,
  showModelInMenu
}: MapActionsMenuProps) {
  return <div className="jua-actions-menu absolute right-0 top-full mt-2 w-48 rounded-xl shadow-2xl shadow-black/50 z-[1100] py-1 border border-white/[0.08]" style={{
    background: 'rgba(15, 23, 42, 0.55)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)',
    isolation: 'isolate'
  }} data-id="element-1532">
      <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
    }} data-id="element-1533" />

      {/* Compact-mode controls at top */}
      {compactMode && <>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenLayers?.();
        onClose();
      }} data-id="element-1534">
            <span className="flex items-center gap-2" data-id="element-1535">
              <Layers size={12} className={activeLayersCount > 0 ? 'text-[#EC4899]' : ''} data-id="element-1536" />
              Weather Layers
            </span>
            {activeLayersCount > 0 && <span className="text-[10px] bg-[#EC4899] text-white rounded-full w-4 h-4 flex items-center justify-center font-bold flex-shrink-0" data-id="element-1537">
                {activeLayersCount}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenPOI?.();
        onClose();
      }} data-id="element-1538">
            <span className="flex items-center gap-2" data-id="element-1539">
              <MapPin size={12} className={activePOIsCount > 0 ? 'text-[#EC4899]' : ''} data-id="element-1540" />
              Points of Interest
            </span>
            {activePOIsCount > 0 && <span className="text-[10px] bg-[#EC4899] text-white rounded-full w-4 h-4 flex items-center justify-center font-bold flex-shrink-0" data-id="element-1541">
                {activePOIsCount}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenModel?.();
        onClose();
      }} data-id="element-1542">
            <span className="flex items-center gap-2" data-id="element-1543">
              <Cpu size={12} className="text-[#EC4899]" data-id="element-1544" />
              Model
            </span>
            {selectedModel && <span className="text-[10px] text-white/50 font-mono" data-id="element-1545">
                {selectedModel}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
        onResetPosition?.();
        onClose();
      }} data-id="element-1546">
            <LocateFixed size={12} data-id="element-1547" /> Reset Position
          </button>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1548" />
        </>}

      {/* Medium-mode: only model row */}
      {!compactMode && showModelInMenu && <>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenModel?.();
        onClose();
      }} data-id="element-1549">
            <span className="flex items-center gap-2" data-id="element-1550">
              <Cpu size={12} className="text-[#EC4899]" data-id="element-1551" />
              Model
            </span>
            {selectedModel && <span className="text-[10px] text-white/50 font-mono" data-id="element-1552">
                {selectedModel}
              </span>}
          </button>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1553" />
        </>}

      <button className="relative w-full px-3 py-2 text-left text-xs text-[#EC4899] hover:bg-[#EC4899]/10 flex items-center gap-2 font-medium" onClick={() => {
      onEditWithAI();
      onClose();
    }} data-id="element-1554">
        <Sparkles size={12} data-id="element-1555" /> Edit with AI
      </button>

      {showResetPosition && !compactMode && <>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1556" />
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
        onResetPosition?.();
        onClose();
      }} data-id="element-1557">
            <LocateFixed size={12} data-id="element-1558" /> Reset Position
          </button>
        </>}

      <div className="h-px bg-white/[0.08] my-1" data-id="element-1559" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1560">
        <Download size={12} data-id="element-1561" /> Download PNG
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1562">
        <Settings2 size={12} data-id="element-1563" /> Display Settings
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1564">
        <Database size={12} data-id="element-1565" /> Edit Data Source
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1566">
        <Save size={12} data-id="element-1567" /> Save Settings
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-1568" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1569">
        <Share2 size={12} data-id="element-1570" /> Share
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1571">
        <Edit2 size={12} data-id="element-1572" /> Edit
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-1573" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
      onToggleBackground?.();
      onClose();
    }} data-id="element-1574">
        {isBackground ? <Minimize2 size={12} data-id="element-1575" /> : <Maximize2 size={12} data-id="element-1576" />}
        {isBackground ? ' Exit Background' : ' Use as Background'}
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
      onDuplicate?.();
      onClose();
    }} data-id="element-1577">
        <Copy size={12} data-id="element-1578" /> Duplicate
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-red-400 hover:bg-red-500/10 flex items-center gap-2" onClick={() => {
      onRemove?.();
      onClose();
    }} data-id="element-1579">
        <Trash2 size={12} data-id="element-1580" /> Delete
      </button>
    </div>;
}